<ispui-link
  (click)="handleClick($event)"
  (keyup.enter)="handleClick($event)"
  (keyup.space)="handleClick($event)"
  [href]="linkHref"
  [target]="target"
  [color]="linkColor"
  [tabIndex]="0"
  role="link"
  type="default-hover"
>
  <ng-container [ngTemplateOutlet]="captionTemplate"></ng-container>
</ispui-link>

<ng-template #captionTemplate>
  <div class="link">
    <ng-container
      *ngIf="!imgPlace || imgPlace === 'left'"
      [ngTemplateOutlet]="imageTemplate"
    ></ng-container>
    {{ caption }}
    <ng-container
      *ngIf="imgPlace === 'right'"
      [ngTemplateOutlet]="imageTemplate"
    ></ng-container>
  </div>
</ng-template>

<ng-template #imageTemplate>
  <isp-svg-icon
    *ngIf="img && img.icon"
    class="link-icon"
    [name]="img.icon"
    [width]="img.width || '20px'"
    [height]="img.height || '20px'"
  ></isp-svg-icon>
  <img
    *ngIf="img && img.url"
    class="link-image"
    [alt]="caption"
    [width]="img.width"
    [src]="img.url"
    [height]="img.height"
  />
</ng-template>
